/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { mq } from "../responsive";

export const Heading = ({ level, children, style }) => {
  const styles = {
    fontWeight: "bold",
    ...style,
  };

  switch (level) {
    case 1:
      return (
        <h1
          css={{
            ...styles,
            fontSize: "4rem",
            lineHeight: "4rem",
            marginBottom: "30px",
          }}
        >
          {children}
        </h1>
      );
    case 2:
      return (
        <h2
          css={{
            fontSize: "3rem",
            lineHeight: "3rem",
            marginBottom: "20px",
            ...styles,
          }}
        >
          {children}
        </h2>
      );
    case 3:
      return (
        <h3
          css={{
            fontSize: "2.5rem",
            lineHeight: "2.5rem",
            ...styles,
          }}
        >
          {children}
        </h3>
      );
    case 4:
    default:
      return (
        <h4
          css={{
            ...styles,
            fontSize: "2rem",
            lineHeight: "2rem",
          }}
        >
          {children}
        </h4>
      );
  }
};

export const Paragraph = ({ type, children, style }) => {
  switch (type) {
    case "quote":
      return (
        <p css={{ fontSize: "12px", lineHeight: "18px", ...style }}>
          {children}
        </p>
      );
    case "normal":
    default:
      return (
        <p
          css={{
            fontSize: "2rem",
            lineHeight: "3rem",

            [mq.md]: {},
            ...style,
          }}
        >
          {children}
        </p>
      );
  }
};
